<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body{
  margin: 0;
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.el-card{
  border: none !important;
  border-radius: 0 !important;
}
.el-row, .el-col{
  height: 100%;
}
.functionIco{
  font-size: 18px !important;
  margin: 4px 6px;
}
.YQ-chatSend{
  float: right;
  margin-right: 12px !important;
}



.YQ-ChatMessage{
  margin-bottom: 60px;
}
.YQ-ChatMessage .YQ-service-message{
  margin-top: 20px;
  padding-left: 12px;
}
.YQ-ChatMessage .YQ-service-message .YQ-service-message-left{
  width: 30px;
  height: 30px;
  float: left;
}
.YQ-ChatMessage .YQ-service-message .YQ-service-message-left img{
  width: 100%;
  height: 100%;
  border-radius: 4px;
  margin-top: 12px;
}
.YQ-ChatMessage .YQ-service-message .YQ-service-message-right{
  width: calc(100% - 50px);
  float: right;
  padding: 0 10px;
}
.YQ-service-message-title{
  font-size: 12px;
  font-weight: bolder;
  margin-bottom: 8px;
}
.YQ-service-message-content{
  font-size: 13px;
  background-color: #eff3f6;
  padding: 8px;
  border-radius: 6px;
  display: inline-block;
  word-break: break-all;
}
.YQ-service-message-content p:first-child {
  margin: 0;
  line-height: 2;
}
.YQ-text-wrap{
  word-break: break-all;
}
.YQ-ChatMessage .YQ-user-message{
  margin-top: 20px;
}
.YQ-user-message-title{
  text-align: right;
  font-weight: bolder;
  margin-bottom: 8px;
  margin-right: 12px;
}
.YQ-user-message-title span{
  font-size: 12px;
}
.YQ-user-message-content{
  margin: 0 12px 0 12px;
}
.YQ-user-message-content span{
  font-size: 13px;
  display: block;
  float: right;
  background-color: #1b7ee1;
  border-radius: 6px;
  padding: 8px;
  line-height: 2;
}

</style>



// WEBPACK FOOTER //
// src/App.vue